<template>
  <div class="ac1">
    <div class="container">
      <!-- banner -->
      <div class="banner"></div>

      <!-- 主容器 -->
      <div class="a1-con">
        <!-- 循环项 -->
        <div
          class="list-item"
          v-for="(item, index) in this.data"
          :key="index"
          @click="gopay(item.id)"
        >
          <!-- 左侧图片 -->
          <div class="item-img">
            <img :src="item.img" alt="" />
          </div>
          <!-- 右侧信息 -->
          <div class="item-info">
            <!-- 标题 -->
            <div class="item-title">{{ item.title }}</div>
            <!-- 发布时间 -->
            <div class="item-time">发布时间:{{ item.time }}</div>
            <!-- 简介 -->
            <div class="item-jj">
              {{ item.jj }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      title="请选择支付方式"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <img src="/imgs/pay.png" />
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "../components/Modal.vue";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      data: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init();
    document.title = "北京计算美学科技有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/info.json").then((res) => {
        const data = res.data;
        this.data = data;
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      if (this.state == 0) {
        // this.$router.push("/pay");
        this.showModal = true;
      }
      // 未登录
      if (this.state !== 0) {
        alert("请登录付费3元后可浏览！！！~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac1 {
  .container {
    box-sizing: border-box;
    padding: 0 100px;
    // banner
    .banner {
      width: 100%;
      height: 400px;
      background: pink;
      margin-top: 100px;
    }
    // 主容器
    .a1-con {
      width: 100%;
      // 循环项
      .list-item {
        width: 100%;
        height: 300px;
        border-bottom: 1px solid #cfcfcf;
        @include flex();
        // 左侧图片
        .item-img {
          width: 35%;
          height: 100%;
          // background-color: #c60023;
          text-align: center;
          img {
            width: 290px;
            height: 190px;
            margin-top: 56px;
          }
        }
        // 右侧信息
        .item-info {
          width: 60%;
          // 标题
          .item-title {
            font-size: 21px;
          }
          // 发布时间
          .item-time {
            font-size: 16px;
            color: #666;
            margin: 15px auto;
          }
          // 简介
          .item-jj {
            font-size: 14px;
            line-height: 35px;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>